module.exports = __webpack_public_path__ + "static/img/muer.d9375237.png";